import Typography from '@mui/material/Typography'

const ChartSelector = ({ path }) => {
  return (
    <div className='py-1 px-2 max-w-150px min-w-150px absolute top-0px bottom-0px left-0px flex flex-col justify-center overflow-auto bg-primary'>
      <Typography className='text-primary-foreground font-bold px-2'>Student distribution</Typography>
    </div>
  )
}

export default ChartSelector
